import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";
import { FormlyFieldConfig } from "@ngx-formly/core";

export class ProductAttachment extends FormlyView{
    constructor(
        fieldDefinition: FieldDefinition,
        operationtype: any
    ) {
        let attachmentFields: FormlyFieldConfig[]= [...fieldDefinition.ppiattachmentItemFields];
        //Added operationtype, necesary for the BR method AP_PPI_2_BR
        attachmentFields[1].fieldGroup![0].props!["operationtype"] = operationtype;

        super(new FormGroup({}), 
            attachmentFields, {});
    }
}